import { Box } from "@material-ui/core"
import { DsText } from "@mvp/design-system"
import React from "react"
import { PhoneNumber } from "../../PhoneNumber"
import { ContentTitle } from "./ContentTitle"
import { modalText } from "./modalText"

export const ThirtyAndOver: React.FC = () => {
  return (
    <>
      <ContentTitle text={modalText.callToComplete} />
      <Box>
        <DsText variant="body1">
          {modalText.thirtyAndOlder.part1}
          <PhoneNumber variant="body1" phoneNumber={modalText.phoneNumber} />
          {modalText.thankYou}
        </DsText>
      </Box>
    </>
  )
}